import React from "react";
import {
  CNavItem,
  CNavLink,
  CSidebar,
  CSidebarHeader,
  CSidebarNav,
} from "@coreui/react";
import { NavLink } from "react-router-dom";
import SimpleBar from "simplebar-react";
import navigation from "../../utils/navLinks";
import NavbarLogo from "../navbarLogo";

/**
 * @function AppSidebar
 * @description Persistent admin sidebar. Intentionally avoids location hooks so
 * the shell and logo stay mounted while NavLink handles active states.
 * @returns JSX for sidebar
 */
const AppSidebar = () => {
  return (
    <CSidebar className="border-end" colorScheme="light" position="fixed">
      <CSidebarHeader className="border-bottom logo-contanier">
        <NavbarLogo />
      </CSidebarHeader>
      <CSidebarNav as={SimpleBar} className="sidebar-nav-scroll">
        {navigation.map((item) => (
          <CNavItem key={item.to}>
            <CNavLink as={NavLink} to={item.to}>
              {item.icon}
              {item.name}
            </CNavLink>
          </CNavItem>
        ))}
      </CSidebarNav>
    </CSidebar>
  );
};

export default React.memo(AppSidebar);
